import { createContext } from 'react';

const EditModalContext = createContext();

export { EditModalContext };
